<!--
 * @Author: 仙道
 * @Date: 2023-10-07 21:52:26
 * @LastEditTime: 2023-10-08 16:38:19
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/components/bigmodel/HomeIndex.vue
-->
<template>
  <div class="chat-home">
    <div v-if="isChat" class="content" ref="scrollRef" @scroll="onScroll">
      <ChatMessage :message="item" v-for="item in state.messageList" :key="item.id" />
    </div>
    <div v-else class="empty">
      <h1>开始聊天</h1>
      <div class="typed">
        <div id="hello-chatgpt"></div>
      </div>
    </div>
    <Search :loading="state.loading" @message="sendMessage" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChatMessage from './ChatMessage.vue'
import Search from './Search.vue'
import { randomUUID } from '@/utils/util.js'
import Typed from 'typed.js'

export default {
  name: 'ChatHomeIndex',
  components: {
    ChatMessage,
    Search
  },
  // 定义属性
  data() {
    return {
      state: {
        loading: false,
        messageList: [],
        isShowBackTop: false
      },
      loadingTyped: null,
      activeId: '',
      scrollRef: null
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters(['']),
    isChat() {
      return this.state.messageList.length > 0
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (!this.activeId) {
      this.activeId = randomUUID()
    }
    // this.loadingTyped = new Typed(`#loading-id-${activeId}`, {
    //   strings: ['', '加载中...'], //输入内容, 支持html标签
    //   typeSpeed: 50
    // })
    this.scrollRef = this.$refs.scrollRef

    new Typed(`#hello-chatgpt`, {
      strings: ['', `快来和小i畅所欲言吧`], //输入内容, 支持html标签
      typeSpeed: 40
    })
  },
  // 方法集合
  methods: {
    onScrollEnd() {
      this.$nextTick(() => {
        if (this.scrollRef) {
          if (this.scrollRef?.scrollHeight && this.scrollRef.scrollTop < this.scrollRef?.scrollHeight) {
            this.scrollRef.scrollTop = this.scrollRef.scrollHeight
          }
        }
      })
    },
    onScroll() {},
    // 发送消息
    sendMessage(searchValue) {
      if (this.state.loading) return
      if (!searchValue) {
        return
      }

      // 添加用户输入的消息
      this.state.messageList.push({
        id: randomUUID(),
        type: 'user',
        content: searchValue
      })

      const activeId = randomUUID() // 获取唯一的uuid

      this.state.messageList.push({
        id: activeId,
        type: 'chatgpt',
        loading: true,
        content: ''
      })

      let loadingTyped = null
      this.$nextTick(() => {
        loadingTyped = new Typed(`#loading-id-${activeId}`, {
          strings: ['', '加载中...'], //输入内容, 支持html标签
          typeSpeed: 50
        })
      })

      this.state.loading = true

      // 发送消息
      // const res = await fetchSendMessage(searchValue).catch((err) => {
      //   console.log(err);
      //   state.loading = false;
      //   state.messageList = state.messageList.map((item) => {
      //     if (item.id === activeId) {
      //       return {
      //         ...item,
      //         loading: false,
      //         error: {
      //           msg: err,
      //         },
      //       };
      //     }
      //     return item;
      //   });
      //   return err;
      // });

      // parentMessageId.value = res.data?.id;
      // const content = res.data?.text;
      const content = `这个问题我还不会！（请联系管理员开通服务）`
      this.state.messageList = this.state.messageList.map(item => {
        if (item.id === activeId) {
          return {
            ...item,
            loading: false,
            content
          }
        }
        return item
      })

      this.onScrollEnd()
      this.$nextTick(() => {
        new Typed(`#text-id-${activeId}`, {
          strings: ['', content], //输入内容, 支持html标签
          typeSpeed: 5,
          showCursor: false,
          onComplete: () => {
            this.state.loading = false
            this.onScrollEnd()
          }
        })
      })
      loadingTyped.destroy() // 销毁loading文字
    }
  }
}
</script>

<style lang="scss" scoped>

.chat-home {
  width: 100%;
  height: calc(100% - 48px);
  display: flex;
  flex-direction: column;
  align-items: center;
  .content {
    width: 100%;
    min-width: 300px;
    // max-width: 800px;
    overflow-y: auto;
    scroll-behavior: smooth;
    height: calc(100% - 108px);
  }
}
@media screen and (max-width: 500px) {
  .content {
    width: 100% !important;
    padding: 0 16px;
  }
}
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;
  text-align: center;

  h1 {
    display: block;
  }

  .typed {
    margin-top: 8px;
    display: flex;
    align-items: center;
    font-size: 20px;
  }
}

</style>
